import Countdown from "react-countdown";
import type { CountdownRendererFn } from "react-countdown/dist/Countdown";

export interface Props {
  endTimeSecondsSinceEpoch: number;
}

const renderer: CountdownRendererFn = ({ days, hours, minutes, completed }) => {
  if (completed) {
    return "Challenge over!";
  } else {
    const daysWord = `day${days === 1 ? "" : "s"}`;
    const hoursWord = `hour${hours === 1 ? "" : "s"}`;
    const minutesWord = `minute${minutes === 1 ? "" : "s"}`;
    // Render a countdown
    return (
      <span>
        {days} {daysWord}, {hours} {hoursWord}, {minutes} {minutesWord} left
      </span>
    );
  }
};

const TimeRemaining = ({ endTimeSecondsSinceEpoch }: Props) => (
  <Countdown
    date={new Date(endTimeSecondsSinceEpoch * 1000)}
    renderer={renderer}
  />
);
export default TimeRemaining;
